import fetch from 'services/request';
import {
  IDateRangeParams,
  IInventorySearchParams,
  IOutOfStockSearchParams,
  IPaymentTypeParams,
  IProductDetailParams,
  IProductDetailSummaryParams,
  IProductSaleRankingParams,
  ISummaryProductsParams,
  IUpdateProductQuantityPayload,
  TimeFilter,
} from './types';

const API_V1 = '/api/v1';
const REPORT_BASE_URL = `${API_V1}/report`;

const apiReport = {
  get: {
    summary: (params: IDateRangeParams) =>
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/summary`,
        params,
      }),

    summaryPaymentType: (params: IDateRangeParams) =>
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/summary-payment-type`,
        params,
      }),

    summaryInventory: (params: IDateRangeParams) =>
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/summary-inventory`,
        params,
      }),

    productDetailSummary: (params: IProductDetailSummaryParams) =>
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/summary-product/${params.productId}`,
        params: {
          startDate: params.startDate,
          endDate: params.endDate
        },
      }),

    inventory: (params: IInventorySearchParams) =>
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/inventory`,
        params,
      }),

    outOfStock: (params: IOutOfStockSearchParams) =>
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/out-of-stock`,
        params: {
          page: params.page,
          size: params.size,
          keySearch: params.keySearch,
          categoryId: params.categoryId,
        },
      }),

    summaryProducts: (params: ISummaryProductsParams) =>
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/summary-products`,
        params: {
          page: params.page ?? 1,
          size: params.size ?? 20,
          keySearch: params.keySearch,
          startDate: params.startDate,
          endDate: params.endDate,
        },
      }),

    productDetail: (params: IProductDetailParams) =>
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/product-detail/${params.productId}`,
        params: {
          page: params.page ?? 1,
          size: params.size ?? 20,
          keySearch: params.keySearch,
          startDate: params.startDate,
          endDate: params.endDate,
        },
      }),
    paymentType: (params: IPaymentTypeParams) =>
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/payment-type`,
        params: {
          startDate: params.startDate,
          endDate: params.endDate,
          paymentType: params.paymentType,
          page: params.page,
          size: params.size,
          keySearch: params.keySearch,
        },
      }),
    summaryProductSale:(params: IDateRangeParams) => 
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/summary-product-sale`,
        params
      }),
    productSale:(params: IProductSaleRankingParams) => 
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/product-sale`,
        params
      }),
    productSaleChart: (params: {type: TimeFilter}) => 
      fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/summary-chart`,
        params
      }),
  },
  print: {
    summarySingleDate: (date: string) =>
      fetch({
        method: 'get',
        url: `${API_V1}/print/summary-single-date`,
        params: { date },
      }),
    summaryRangeDate: (params: IDateRangeParams) =>
      fetch({
        method: 'get',
        url: `${API_V1}/print/summary-range-date`,
        params,
      }),
    getProductRangeDate: (
      productId: string,
      startDate: string,
      endDate: string
    ) =>
      fetch({
        method: 'get',
        url: `${API_V1}/print/by-product-range-date/${productId}`,
        params: {
          startDate,
          endDate,
        },
      }),

    getProductSingleDate: (productId: string, date: string) =>
      fetch({
        method: 'get',
        url: `${API_V1}/print/by-product-on-date/${productId}`,
        params: {
          date,
        },
      }),
    getPaymentType: (params: IDateRangeParams) =>
      fetch({
        method: 'get',
        url: `${API_V1}/print/payment-type`,
        params,
      }),
  },
  delete: {
    product: (productId: string) =>
      fetch({
        method: 'delete',
        url: `${API_V1}/product/delete/${productId}`,
      }),
  },
  update: {
    productMultipleQuantity: (payload: IUpdateProductQuantityPayload[]) =>
      fetch({
        method: 'post',
        url: `${API_V1}/product/update-multiple-quantity`,
        body: payload,
      }),
  },
};

export default apiReport;
